<div class="section" id="education">
    <div class="container cc-education">
      <div class="h4 text-center mb-4 title">Education</div>
<hr>
      <div class="card">
        <div class="row">
          <div class="col-md-3 bg-primary" data-aos="fade-right" data-aos-offset="50" data-aos-duration="500">
            <div class="card-body cc-education-header">
              <div class="h5">Bloom Institute of Technology (Formerly Lambda School)</div>
            </div>
          </div>
          <div class="col-md-9" data-aos="fade-left" data-aos-offset="50" data-aos-duration="500">
            <div class="card-body">
              <div class="h5">Full Stack Web Development Java + Technical Interviewing</div>
               <h4>Silicon Valley, CA</h4>
               <p>
                Lambda School is a 9+ month Computer Science & Software Engineering Academy that provides an immersive hands-on curriculum with a focus on computer science, and fullstack web development. Students in this program...
                  <li>Approach all coding challenges using pair programming.</li>
                  <li>Utilize agile software development and Git workflow on all projects.</li>
                  <li>Gain hands-on experience with client and server testing</li>
                  <li>Design original user experiences across a range of web and mobile platforms, from ideation, to wireframing, to final product.</li>
                  <li>Complete all curriculum course work including: React, React Native, Redux, Node, Express, MongoDB, Jest, Python, Django, etc.</li>
                  <li>Write production-ready code using ReactJS, Redux, and CSS on the frontend and NodeJS and Express on the backend to build single page applications.</li>
               
               </p>
            </div>
          </div>
        </div>
      </div>
      